








































































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { IRules, sValidation } from '../UI/Form/ValidationModule';
import { validateRequired, validateType } from '../UI/Form/Validations';
import Locale from '@/utils/locale';

const validateRequiredIfNotNull: sValidation = data => {
  if (data.dataValue === null) return true;

  return validateRequired()(data);
};

@Component
export default class LoginForm extends Vue {
  private loginCredentials = {
    email: null as string | null,
    password: null as string | null,
  };

  private loading = false;
  private errorMessage = '';

  private serverHost: string | undefined = process.env.VUE_APP_API_HTTP;

  private async signIn() {
    this.loading = true;

    try {
      const response = await fetch(`${this.serverHost}/accounts/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.loginCredentials.email!.toLowerCase(),
          password: this.loginCredentials.password,
        }),
      });

      this.loading = false;

      if (response.status === 200) {
        this.errorMessage = '';
        const payload = await response.json();
        this.receiveToken(payload.token);
        return;
      }

      this.loginCredentials.email = '';
      this.loginCredentials.password = '';

      if (response.status === 401) {
        this.errorMessage = this.$t('Account.invalidLogin') as string;
      } else if (response.status === 403) {
        this.errorMessage = this.$t('Account.ipSuspended') as string;
      } else {
        this.errorMessage = this.$t('Error.somethingWentWrong') as string;
      }
    } catch (error) {
      this.loading = false;
      this.errorMessage = this.$t('Error.somethingWentWrong') as string;
    }
  }

  private validForm = true;

  private rules: IRules = {
    email: [
      {
        validation: validateRequiredIfNotNull,
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.email') }),
      },
      {
        validation: validateType('email'),
        message: i18n => i18n.t('Error.email'),
      },
    ],
    password: [
      {
        validation: validateRequiredIfNotNull,
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.password') }),
      },
    ],
  };

  @Emit()
  private receiveToken(token: string) {
    return token;
  }

  private validResetPasswordForm = true;
  public showForgottenPasswordDialog = false;
  private resetEmail = '';
  private requestPasswordResetError = '';
  private requestPasswordResetSuccess = false;

  private async requestPasswordReset() {
    try {
      const response = await fetch(`${this.serverHost}/accounts/request_password_reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          login: this.resetEmail.toLowerCase(),
          locale: Locale.get(),
        }),
      });

      if (response.status === 200) {
        this.resetEmail = '';
        this.requestPasswordResetError = '';
        this.requestPasswordResetSuccess = true;
        return;
      }
      this.requestPasswordResetError = this.$t('Error.somethingWentWrong') as string;
      this.resetEmail = '';
    } catch (error) {
      this.requestPasswordResetError = this.$t('Error.somethingWentWrong') as string;
      this.resetEmail = '';
    }
  }
}
